<mat-card>
    <mat-card-content>
        <h4>Edit Category</h4>
        <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()" class="basic-form">
            <div fxLayout="row wrap" fxFlexAlign="center" class="row">
                <mat-form-field fxFlex="100" class="p-10">
                    <mat-label>Name</mat-label>
                    <input type="text" matInput formControlName="name" placeholder="Name">
                    <mat-error *ngIf="categoryForm.controls.name.hasError('required')">
                        Name is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
        
                <mat-form-field fxFlex="100" class="p-10">
                    <mat-label>Description</mat-label>
                    <input type="text" matInput formControlName="description" placeholder="Description">
                </mat-form-field>
        
                <div class="mat-form-field p-10">
                    <mat-slide-toggle formControlName="isRequired">Required</mat-slide-toggle>
                </div>
        
                <div class="mat-form-field p-10">
                    <mat-slide-toggle formControlName="isSingleSelect">Single Select</mat-slide-toggle>
                </div>
        
                <mat-form-field>
                    <mat-label>Company</mat-label>
                    <input matInput #companyInput type="text" formControlName="company" placeholder="Search companies"
                        [matAutocomplete]="companiesAutoComplete">
                    <mat-autocomplete #companiesAutoComplete="matAutocomplete" [displayWith]="getCompanyName">
                        <mat-option *ngFor="let item of companies" [value]="item">
                            <div [innerHtml]="item.name | highlight: companyInput.value"></div>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
        
                <mat-form-field>
                    <mat-label>Parent Category</mat-label>
                    <input matInput #parentCategoryInput type="text" formControlName="parentStyleCategory"
                        placeholder="Search categories" [matAutocomplete]="categoriesAutoComplete">
                    <mat-autocomplete #categoriesAutoComplete="matAutocomplete" [displayWith]="getCategoryName">
                        <mat-option *ngFor="let item of filteredCategories" [value]="item">
                            <div [innerHtml]="item.name | highlight: parentCategoryInput.value"></div>
                        </mat-option>
                    </mat-autocomplete>
                    <!-- <mat-error *ngIf="categoryForm.controls.parentStyleCategory.hasError('requireMatch')">
                        Select a category
                    </mat-error> -->
                </mat-form-field>
        
            </div>
            <div fxLayoutAlign="end center" fxLayoutGap="15px">
                <button type="submit" class="add-action-button" mat-flat-button color="primary"
                    [disabled]="!categoryForm.valid">
                    <mat-icon>done</mat-icon> Save
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>

<div fxLayout="row" fxLayout.lt-md="column" *ngIf="!isAddMode">
    <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <div id="inStyleListContainer" cdkDropList [cdkDropListData]="inStyleList"
                (cdkDropListDropped)="drop($event)" cdkDropListConnectedTo="outStyleListContainer">
                <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
                    fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
                    <label><span class="text-info">{{ getStyles(true) }}</span> styles in your category.</label>
                </div>
                <mat-card [class.banner-incomplete]="!isStyleListModified" [class.banner-warning]="isStyleListModified"
                    [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
                    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                        <div fxFlex="60" fxLayoutAlign="start center" fxLayout="row">
                            <strong *ngIf="!styleSelectedInList(true)" class="text-center"
                                [ngClass.lt-sm]="{'card-title': true}">select styles</strong>
                            <strong *ngIf="styleSelectedInList(true)" class="text-center"
                                [ngClass.lt-sm]="{'card-title': true}"><span class="text-info">{{
                                    getStylesSelected(true) }}</span> styles selected</strong>
                        </div>
                        <div fxFlex="40" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column"
                            fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                            <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column"
                                fxLayoutAlign.lt-sm="center center" class="date-text">
                                <button *ngIf="isStyleListModified" mat-icon-button color="primary"
                                    matTooltip="Save Style Range" aria-label="Save Style Range"
                                    (click)="updateCategoryStyles()">
                                    <mat-icon>save</mat-icon>
                                </button>
                                <button *ngIf="styleSelectedInList(true)" mat-icon-button color="basic"
                                    matTooltip="Cancel Select" aria-label="Cancel Select"
                                    (click)="clearAllSelectedStyles(true)">
                                    <mat-icon>clear</mat-icon>
                                </button>
                                <button mat-icon-button color="accent" matTooltip="Select All Styles"
                                    aria-label="Select All Styles" (click)="selectAllStyles(true)">
                                    <mat-icon>done_all</mat-icon>
                                </button>
                                <button *ngIf="styleSelectedInList(true)" mat-icon-button color="warn"
                                    matTooltip="Remove Style(s) from Category"
                                    aria-label="Remove Style(s) from Category" (click)="transferList(true)">
                                    <mat-icon fxShow fxHide.lt-sm>keyboard_double_arrow_right</mat-icon>
                                    <mat-icon fxShow fxHide.gt-sm>keyboard_double_arrow_down</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <div *ngFor="let item of inStyleList">
                    <style-card cdkDrag [item]="item" [readonly]="false" [selected]="item.selected" [showCategory]="false"
                        (click)="selectStyle(item)">
                    </style-card>
                </div>
            </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <div id="outStyleListContainer" cdkDropList [cdkDropListData]="outStyleList"
            (cdkDropListDropped)="drop($event)" cdkDropListConnectedTo="inStyleListContainer">
            <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
                fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
                <label><span class="text-info">{{ getStyles(false) }}</span> styles available</label>
            </div>
            <ng-container>
                <mat-card class="banner-incomplete" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
                    <mat-card-content fxLayoutAlign="center center" fxLayout="row-reverse" fxLayout.lt-sm="column">
                        <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row">
                            <strong *ngIf="!styleSelectedInList(false)" class="text-center"
                                [ngClass.lt-sm]="{'card-title': true}">select styles</strong>
                            <strong *ngIf="styleSelectedInList(false)" class="text-center"
                                [ngClass.lt-sm]="{'card-title': true}"><span class="text-info">{{
                                    getStylesSelected(false) }}</span> styles selected</strong>
                        </div>
                        <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column"
                            fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                            <div fxLayoutAlign="end center" fxLayout="row-reverse" fxLayout.lt-sm="column-reverse"
                                fxLayoutAlign.lt-sm="center center" class="date-text">
                                <button *ngIf="styleSelectedInList(false)" mat-icon-button color="basic"
                                    matTooltip="Cancel Select" aria-label="Cancel Select"
                                    (click)="clearAllSelectedStyles(false)">
                                    <mat-icon>clear</mat-icon>
                                </button>
                                <button mat-icon-button color="accent" matTooltip="Select All Styles"
                                    aria-label="Select All Styles" (click)="selectAllStyles(false)">
                                    <mat-icon>done_all</mat-icon>
                                </button>
                                <button *ngIf="styleSelectedInList(false)" mat-icon-button color="primary"
                                    matTooltip="Add Style(s) to Category" aria-label="Add Style(s) to Category"
                                    (click)="transferList(false)">
                                    <mat-icon fxShow fxHide.lt-sm>keyboard_double_arrow_left</mat-icon>
                                    <mat-icon fxShow fxHide.gt-sm>keyboard_double_arrow_up</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <div *ngFor="let item of outStyleList">
                    <style-card cdkDrag [item]="item" [readonly]="false" [showCategory]="true" [selected]="item.selected"
                        (click)="selectStyle(item)">
                    </style-card>
                </div>
            </ng-container>
        </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>